
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import FactoryIcon from '@mui/icons-material/Factory';
import InventoryIcon from '@mui/icons-material/Inventory';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import ApprovalIcon from '@mui/icons-material/Approval';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import AddTaskIcon from '@mui/icons-material/AddTask';
import PolylineIcon from '@mui/icons-material/Polyline';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';



const OrderMgmt = {
  id: '4',
  title: 'Order Mgmt',
  type: 'group',
  role: 'PHARMA_OMS_MANAGER, PHARMA_OMS_ADMIN, PHARMA_OMS_MD,PHARMA_OMS_SALES',
  children: [
    // {
    //   id: 'mdapprovallist',
    //   title: 'My Approval List',
    //   type: 'item',
    //   url: '/',
    //   bottomMenu:'APPROVAL-LIST',
    //   icon: ApprovalIcon
    // },
    {
      id: 'salesreport',
      title: 'Sales Report',
      type: 'item',
      url: '/',
      bottomMenu:'SALES-REPORT',
      icon: AssessmentIcon
    },
    {
      id: 'pharmaorder',
      title: 'Order List',
      type: 'item',
      url: '/',
      bottomMenu:'ORDERS',
      icon: ShoppingBagIcon
    },
    
    {
      id: 'party',
      title: 'Party Mgmt',
      type: 'item',
      url: '/',
      bottomMenu:'PARTY',
      icon: ContactEmergencyIcon
    },
    {
      id: 'bilty',
      title: 'Bilty Mgmt',
      type: 'item',
      url: '/',
      bottomMenu:'BILTY',
      icon: LocalShippingIcon
    },

    {
      id: 'composition',
      title: 'Composition',
      type: 'item',
      url: '/',
      bottomMenu:'COMPOSITION',
      icon: PolylineIcon
    }
    ,

    {
      id: 'ordertracking',
      title: 'Order Tracking',
      type: 'item',
      url: '/',
      bottomMenu:'ORDER-TRACKING',
      icon: TroubleshootIcon
    }
  ]
};

export default OrderMgmt;